import { useWorkflows } from '@debbie/cortex/dist/workflows/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import SearchableSelect from './SearchableSelect.js';
const workflowId = (workflow) => workflow.workflowId;
const workflowTitle = (workflow) => workflow.title;
const WorkflowSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    const workflows = useWorkflows();
    return (React.createElement(SearchableSelect, { ...props, items: workflows, getId: workflowId, getLabel: workflowTitle, placeholder: props.placeholder ?? lang.creditors.selectDefaultChain, labels: {
            search: lang.connect.searchWorkflows,
            all: lang.workflows.workflows,
        }, recentsStorageKey: "debbie.workflowSelect.recentlyUsed" }));
};
export default WorkflowSelect;
//# sourceMappingURL=WorkflowSelect.js.map